module.exports = __webpack_public_path__ + "static/media/logo-berry-purple.5bde6fc3.svg";